import React, {ReactNode, useEffect, useState} from "react"
import * as styles from './styles.module.scss';
import cls from "classnames";
import {PlansTableTheme} from "src/components/organisms/PlansTable/index";

type ChildArray = (React.ReactNode | string)[]
type Column = {
    opt1: ChildArray
    opt2: ChildArray
}

export type PricingRowsTableProps = {
    data?: {
        firstColumn: Column
        secondColumn: Column
    }
    modal1: string,
    modal2: string
    theme?: PlansTableTheme
}

export const PricingRowsTable = (props: PricingRowsTableProps) => {

    const firstColumn = props?.data?.firstColumn
    const secondColumn = props.data?.secondColumn

    const {modal1, modal2, theme} = props

    const [firstSwitch, setFirstSwitch] = useState(false)
    const [secondSwitch, setSecondSwitch] = useState(false)

    const switchFirst = () => {
        setFirstSwitch(state => {
            return !state
        })
    }

    const switchSecond = () => {
        setSecondSwitch(state => {
            return !state
        })
    }

    const updateRows = () => {
        const column1 = firstSwitch ? firstColumn?.opt2 : firstColumn?.opt1
        const column2 = secondSwitch ? secondColumn?.opt2 : secondColumn?.opt1
        const rows = []

        if (column1 && column2) {
            for (let i = 0; i < Math.max(column1?.length, column2.length); i++) {
                rows.push({first: column1[i] ? column1[i] : "", second: column2[i] ? column2[i] : ""})
            }
        }

        return rows
    }

    let [rows, setRows] = useState(updateRows())

    useEffect(() => {
        setRows(updateRows())
    }, [firstSwitch, secondSwitch])

    return (
        <>
            {props.data &&
                <tr className={styles.tr}>
                    <td className={cls(styles.groupHeading, styles.last)}>Pricing</td>
                    <td className={styles.switcher}>
                        <span className={cls(styles.type, firstSwitch ? "" : "color-light-blue")}>Server</span>
                        <label className={styles.switchWrapper}>
                            <input type="checkbox" checked={firstSwitch} onChange={switchFirst}/>
                            <span className={styles.slider}></span>
                        </label>
                        <span className={cls(styles.type, firstSwitch ? "color-light-blue" : "")}>Desktop</span>
                    </td>
                    <td className={styles.switcher}>
                        <span className={cls(styles.type, secondSwitch ? "" : "color-light-blue")}>Server</span>
                        <label className={styles.switchWrapper}>
                            <input type="checkbox" checked={secondSwitch} onChange={switchSecond}/>
                            <span className={styles.slider}></span>
                        </label>
                        <span className={cls(styles.type, secondSwitch ? "color-light-blue" : "")}>Desktop</span>
                    </td>
                </tr>
            }
            {props.data && rows.map((row, index) => {
                return <tr className={styles.tr}>
                    <td className={styles.spacer}></td>
                    <td className={row.first && index != rows.length - 1 ? styles.td : styles.spacer}>{row.first}</td>
                    <td className={row.second && index != rows.length - 1 ? styles.td : styles.spacer}>{row.second}</td>
                </tr>
            })}
            <tr className={styles.tr}>
                <td className={styles.spacer}></td>
                <td className={styles.spacer}>
                    <button data-bs-toggle="modal" data-bs-target={modal1} className={cls(styles.button, "bg-white", styles.buttonBordered)}>
                        Get a Quote
                    </button>
                </td>
                <td className={styles.spacer}>
                    <button data-bs-toggle="modal" data-bs-target={modal2} className={cls(styles.button, theme ? "bg-" + theme : "bg-light-blue", "color-white")}>
                        Get a Quote
                    </button>
                </td>
            </tr>
        </>
    )
}
